(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fjs--image-text-apps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('fjs-typewriter-heading')) return;

    class FjsTypewriterHeading extends HTMLElement {
      connectedCallback() {
        if (this.dataset.started === 'true') return;
        var element = this;

        // Wait until child nodes exist. The start tag can connect before they are parsed.
        window.requestAnimationFrame(function () {
        if (element.dataset.started === 'true') return;
        var output = element.querySelector('[data-typewriter-output]');
        var caret = element.querySelector('[data-typewriter-caret]');
        var text = element.getAttribute('data-text') || '';
        var speed = parseInt(element.getAttribute('data-speed'), 10);
        if (!output) return;
        element.dataset.started = 'true';
        if (!speed || speed < 16) speed = 45;
        var delay = parseInt(element.getAttribute('data-delay'), 10) || 0;

        var showFinal = function () {
          output.textContent = text;
          if (caret) caret.hidden = true;
          element.classList.add('is-typing');
        };

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          showFinal();
          return;
        }

        var index = 0;
        var step = function () {
          index += 1;
          output.textContent = text.slice(0, index);
          if (index < text.length) {
            element._timer = window.setTimeout(step, speed);
          } else if (caret) {
            caret.hidden = true;
          }
        };

        var play = function () {
          if (element.dataset.playing === 'true') return;
          element.dataset.playing = 'true';
          output.textContent = '';
          element.classList.add('is-typing');
          if (caret && delay > 0) caret.hidden = true;
          var run = function () {
            if (caret) caret.hidden = false;
            element._timer = window.setTimeout(step, speed);
          };
          if (delay > 0) {
            element._timer = window.setTimeout(run, delay);
          } else {
            run();
          }
        };

        var arm = function () {
          var rect = element.getBoundingClientRect();
          var inView = rect.bottom > 0 && rect.top < window.innerHeight * 0.92;
          if (inView) {
            play();
            return;
          }

          if ('IntersectionObserver' in window) {
            var observer = new IntersectionObserver(function (entries) {
              if (entries.some(function (entry) { return entry.isIntersecting; })) {
                observer.disconnect();
                play();
              }
            }, { threshold: 0.4 });
            observer.observe(element);
          } else {
            play();
          }
        };

        arm();
        });
      }

      disconnectedCallback() {
        window.clearTimeout(this._timer);
      }
    }

    customElements.define('fjs-typewriter-heading', FjsTypewriterHeading);
  })();

  } catch(e) { console.error(e); }
})();
})();
